export const parsePeriodId = (periodId: string) => {
  const [startDate, endDate] = periodId.split('_')
  const [startYear, startMonth] = startDate.split('-')
  const [endYear, endMonth] = endDate.split('-').map(Number)

  return {
    startDate: new Date(`${startYear}-${startMonth}-01`),
    endDate: new Date(endYear, endMonth, 0) // Last day of the month by using day 0 of next month
  }
}

export const generatePeriodId = (startDate: Date, endDate: Date) => {
  const startYear = startDate.getFullYear()
  const startMonth = String(startDate.getMonth() + 1).padStart(2, '0')
  const endYear = endDate.getFullYear()
  const endMonth = String(endDate.getMonth() + 1).padStart(2, '0')
  return `${startYear}-${startMonth}_${endYear}-${endMonth}`
}
